import { render } from "./SampleIssueIcon.vue?vue&type=template&id=79a1d298"
import script from "./SampleIssueIcon.vue?vue&type=script&lang=js"
export * from "./SampleIssueIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Icons/SampleIssueIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79a1d298"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79a1d298', __exports__)) {
    console.log('reload')
    api.reload('79a1d298', __exports__)
  }
  
  module.hot.accept("./SampleIssueIcon.vue?vue&type=template&id=79a1d298", () => {
    console.log('re-render')
    api.rerender('79a1d298', render)
  })

}


export default __exports__